var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashflowActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cash_flow_ico_O") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large_review",
    transform: "translate(-29.000000, -560.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(25.000000, 424.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cash_flow_ico_O",
    transform: "translate(4.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4595,1.6435 L12.4085,4.7545 C13.8335,5.1305 15.0005,6.7025 15.0005,8.2495 L15.0005,18.7595 C15.0005,20.3075 13.8295,21.2825 12.3995,20.9265 L3.3505,18.4665 C1.9205,18.1125 0.7505,16.5575 0.7505,15.0095 L0.7505,3.5625 C0.7505,2.0155 1.9525,0.7495 3.4215,0.7495 L17.2505,0.7495 C18.9065,0.7495 20.2505,2.0935 20.2505,3.7495 L20.2505,12.7025 C20.2505,14.3795 18.8725,15.7495 17.1395,15.7495 L15.0005,15.7495",
    id: "Stroke-1",
    stroke: "#92CDE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875,11.25 C10.254,11.25 9.75,11.754 9.75,12.375 C9.75,12.996 10.254,13.5 10.875,13.5 C11.496,13.5 12,12.996 12,12.375 C12,11.754 11.496,11.25 10.875,11.25",
    id: "Fill-3",
    fill: "#92CDE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25,8.25 L15,8.25",
    id: "Stroke-5",
    stroke: "#92CDE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashflowActive);
export default __webpack_public_path__ + "static/media/cashflow-active.866ba7c10354d559eeda99ff6c908474.svg";
export { ForwardRef as ReactComponent };